import React from "react";
import BarcodeReader from "react-barcode-reader";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox
} from "antd";
import moment from "moment";
import "./styles.css";

import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
} from "../../../common/types/regularExpresionType";


import Productos from "./FormModal/Productos";
import Referencias from "./FormModal/Referencias";
import Footer from "./FormModal/Footer";
import Cuotas from "./FormModal/Cuotas";
import Garante from "./FormModal/Garante";


import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import dialog from "../../../common/utility/dialog";

import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  PORCENTAJE_PERCEPCION
} from "../../../common/types/parametroType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleScan = this.handleScan.bind(this);
  }

  handleScan(data) {
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue
    );
  }
  handleError(err) {
    alert("error");
    console.error(err);
  }

  findDaysAndDates = (property, value) => {
    if (property === "diasVencimiento") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const diasVencimiento = parseInt(value);
      this.props.form.setFieldsValue({
        fechaVencimientoStr: fecha.add("days", diasVencimiento),
      });
    }

    if (property === "fechaVencimientoStr") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const fechaVencimiento = moment(value, "DD/MM/YYYY");
      this.props.form.setFieldsValue({
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }
  };

  handleSearchAutocompleteCliente = async (value) => {
    const result = this.props.formValues.clientes
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.numeroDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ clientes: result });
  };

  handleChangeAutocompleteCliente = (a, element) => {
    this.props.form.setFieldsValue(
      {
        documentoCliente: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idCliente",
          element.props.data.idEntidad + "-" + element.props.data.id,
          this.props.form
        );
      }
    );
  };

  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  handleCalculateDetail = (row, property, value, numberDecimals, index) => {
    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    /********* Datos de parametro ******/
    var porcentajeIGV =18;
    var idImpuesto = this.props.form.getFieldValue("idImpuesto");
    var idPrestamo = this.props.form.getFieldValue("idPrestamo");
    porcentajeIGV =  porcentajeIGV ;

    var porcentajeISC = parseFloat(
      params.filter(
        (m) => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA
      )[0].valor
    );
    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;

    /*********** Datos por fila ********/
    var flagChangeTotal = false;
    var flagAfecto =
      property === "arrFlagAfecto"
        ? value
        : this.props.form.getFieldValue(`arrFlagAfecto[${row.identifier}]`);
    var flagGratuito = false;
    var flagISC =
      property === "arrFlagISC"
        ? value
        : this.props.form.getFieldValue(`arrFlagISC[${row.identifier}]`);
    var precioUnitario = this.fetchFieldValue(
      row.identifier,
      "arrPrecioUnitario"
    );
    var cantidad = this.fetchFieldValue(row.identifier, "arrCantidad");
    var porcentajeDescuento = 0;
    var importeDescuento = 0;
    var total = this.fetchFieldValue(row.identifier, "arrTotal");
    var UnidadMedida = this.props.form.getFieldValue(`arridUnidadMedida[${row.identifier}]`).key;
    var LstUnidadMedida = this.props.formValues.unidadesMedida.filter((m) => m.nombre == UnidadMedida);
    var idUnidadMedida = LstUnidadMedida.length == 0 ? UnidadMedida : LstUnidadMedida[0].id;


    if (porcentajeDescuento > 100) {
      message.warning("El porcentaje de descuento no puedo ser mayor a 100%");
      return;
    }

    /*********** VALIDACION CASOS EXONERADOS INAFECTOS ********/

    if (!flagAfecto) {
      flagPrecioIncluyeIGV = 0;
    }
    if (property == "arridUnidadMedida") {
      idUnidadMedida = value;
    }

    /*********** Datos por fila (bloquear checks) ********/
    if (flagGratuito) {
      flagAfecto = false;
      flagISC = false;
    }

    /*********** Calculo precios unitarios ********/
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
    var precioUnitarioSinIGV = flagPrecioIncluyeIGV
      ? precioUnitario / divisorCalculoSubTotal
      : precioUnitario;

    /*********** Calculo por ISC ********/
    var importeISC = flagISC ? precioUnitarioSinIGV * (porcentajeISC / 100) : 0;
    var precioUnitarioISC = flagISC ? precioUnitarioSinIGV + importeISC : 0;
    var totalDetalle = flagISC
      ? cantidad * precioUnitarioISC
      : cantidad * precioUnitarioSinIGV;

    /*********** Calculo totales ********/
    var subTotal = totalDetalle;
    var igv = parseFloat(
      (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
    );
    total = parseFloat((subTotal + igv).toFixed(2));

    if (property === "arrTotal" && parseFloat(newValue) !== total) {
      flagISC = false;
      importeISC = 0;
      precioUnitarioISC = 0;
      flagChangeTotal = true;

      /*********** Calculo totales ********/
      total = parseFloat(value);
      porcentajeDescuento = 0;
      importeDescuento = 0;
      subTotal = parseFloat(
        (flagAfecto ? total / (1 + porcentajeIGV / 100) : total).toFixed(2)
      );

      /*********** Calculo por ISC ********/
      totalDetalle = flagISC ? cantidad * precioUnitarioISC : subTotal;

      /*********** Calculo Cantidad ********/
      cantidad = parseFloat((subTotal / precioUnitarioSinIGV).toFixed(2));
      if (cantidad === 0) cantidad = 1;

      /*********** Calculo IGV ********/
      igv = flagAfecto ? subTotal * (porcentajeIGV / 100) : 0;
    }

    /*********** Calculo descuentos ********/
    if (importeDescuento > 0 || porcentajeDescuento > 0) {
      var calculoimporteDescuento = 0;
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuento = parseFloat(
          (total * (porcentajeDescuento / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuento = parseFloat(
          (totalDetalle * (porcentajeDescuento / 100)).toFixed(2)
        );
      }

      if (
        importeDescuento !== calculoimporteDescuento &&
        property === "arrImporteDescuento"
      )
        porcentajeDescuento = 0;
      else importeDescuento = calculoimporteDescuento;

      if (flagPrecioIncluyeIGV) {
        total = total - importeDescuento;

        if (flagAfecto) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        subTotal = subTotal - importeDescuento;

        if (flagAfecto) {
          var igv = parseFloat(
            (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }
    }

    /*********** Calculo gratuito ********/
    if (flagGratuito) {
      porcentajeDescuento = 0;
      importeDescuento = 0;
      igv = 0;
      subTotal = 0;
      total = 0;
    }

    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var dataNueva = {
      identifier: row.identifier,
      numeroLote: this.props.form.getFieldValue(`arrNumeroLote[${row.identifier}]`),
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      codigo: this.props.form.getFieldValue(`arrcodigo[${row.identifier}]`),
      idProducto: row.idProducto,
      idTipoProducto: row.idTipoProducto,
      precioPromedio: row.precioPromedio,
      porcentajeMargenComercial: row.porcentajeMargenComercial,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario,
      porcentajeDescuento,
      importeDescuento,
      total,
      flagAfecto,
      flagISC,
      flagOtrosImpuesto: false, // OMITIDO POR EL MOMENTO
      flagGratuito,
      flagChangeTotal,
      subTotal,
      isItemLibre: row.isItemLibre == undefined ? false : row.isItemLibre,
      idUnidadMedida: idUnidadMedida,
      flagConversion: row.flagConversion
    };
    detalleProductosFilter.splice(index, 0, dataNueva);

    /*********** Re-Calcular Suma SubTotal ********/
    var sumaTotalAfecto = this.fetchSumaTotalAfecto(
      row.identifier,
      flagAfecto,
      flagGratuito,
      total
    );
    var sumaTotalInafecto = this.fetchSumaTotalInafecto(
      row.identifier,
      flagAfecto,
      flagGratuito,
      total
    );

    /*********** Calculo suma detalle ********/
    var sumaImporteDescuento = 0;
    var sumaIsc = this.fetchFieldValueSum(
      row.identifier,
      "arrIsc",
      cantidad === 0 ? 0 : importeISC
    );
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", total);
    var sumaSubTotal = parseFloat(
      (sumaTotalAfecto / divisorCalculoSubTotal + sumaTotalInafecto).toFixed(2)
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaInteres: 0,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      [`arrFlagAfecto[${row.identifier}]`]: flagAfecto,
      [`arrFlagISC[${row.identifier}]`]: flagISC,
      [`arrIsc[${row.identifier}]`]: cantidad === 0 ? 0 : importeISC,
      [`arrPrecioUnitario[${row.identifier}]`]: precioUnitario.toFixed(5),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(3),
      [`arrTotalDetalle[${row.identifier}]`]: totalDetalle.toFixed(2),
      [`arrSubTotal[${row.identifier}]`]: subTotal.toFixed(2),
      [`arrIgv[${row.identifier}]`]: igv.toFixed(2),
      [`arrTotal[${row.identifier}]`]: total.toFixed(2),
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    if (idPrestamo.key == 1 && idPrestamo != undefined && sumaTotal > 0) {
      this.fetchTasa();
    }
  };

  handleRemoverProducto = (row) => {
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var sumaImporteDescuento = 0;
    var sumaIsc = this.fetchFieldValueSum(row.identifier, "arrIsc", 0);
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
    var sumaSubTotal = this.fetchFieldValueSum(
      row.identifier,
      "arrSubTotal",
      0
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaInteres: 0,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    this.props.onRemoverProducto(row, this.props.form);

  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };

  fetchSumaTotalAfecto = (
    identifier,
    paramFlagAfecto,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagAfecto =
        identifier === key
          ? paramFlagAfecto
          : this.props.form.getFieldValue("arrFlagAfecto")[key];
      var flagGratuito = false;
      if (flagAfecto && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchSumaTotalInafecto = (
    identifier,
    paramFlagAfecto,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagAfecto =
        identifier === key
          ? paramFlagAfecto
          : this.props.form.getFieldValue("arrFlagAfecto")[key];
      var flagGratuito = false;
      if (!flagAfecto && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  handleChangeTotals = (property, value) => {
    if (property === "flagPercepcion" && value) {
      var porcentajePercepcion = parseFloat(
        auth
          .user()
          .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
          .valor
      );
      var importePercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) *
        (porcentajePercepcion / 100);
      var totalPercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion;

      this.props.form.setFieldsValue({
        porcentajePercepcion,
        importePercepcion,
        totalPercepcion,
        flagDetraccion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        idDetraccion: undefined,
      });
    }

    if (property === "flagDetraccion" && value) {
      this.props.form.setFieldsValue(
        {
          flagPercepcion: false,
        },
        () => {
          this.props.form.validateFields(["idDetraccion"], { force: true });
        }
      );
    }

    if (property === "idDetraccion") {
      var importeDetraccion =
        this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100);
      var totalDetraccion =
        this.fetchFieldValueSum("", "arrTotal", 0) - importeDetraccion;

      this.props.form.setFieldsValue({
        flagPercepcion: false,
        porcentajePercepcion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        porcentajeDetraccion: value,
        importeDetraccion,
        totalDetraccion,
      });
    }
  };

  fetchReferencias = (values) => {

    var result = [];

    var flagReferencia = this.props.form.getFieldValue("flagReferencia");
    if (!flagReferencia) {
      this.props.formValues.listaComprobanteReferencia.forEach((item) => {
        result.push({
          idTipoComprobante: item.idTipoComprobante,
          flagInterno: item.flagInterno,
          idReferenciaOrigen: item.idReferenciaOrigen,
          idReferencia: item.idReferencia,
          serie: item.serie,
          documento: item.documento,
        });
      });
      return result;
    }

    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key, value] of Object.entries(obj)) {
      keys.push(key);
    }

    keys.forEach((key) => {
      result.push({
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };

  fetchGarantes = (values) => {

    var result = [];
    var keys = [];
    var obj = Object.assign({}, values.arrGarante);

    for (var [key, value] of Object.entries(obj)) {
      keys.push(key);
    }

    keys.forEach((key) => {
      result.push({
        idGarante: values.arrGarante[key].key,
        nroDocumento: null,
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };

  fetchTasa = () => {
    debugger
    var valorInicio = 1;
    //  var intereses = (this.props.form.getFieldValue('tasa') + valorInicio);
    const tasa = parseFloat(this.props.form.getFieldValue('tasa')) || 0;
    const intereses = (tasa / 100) + valorInicio;

    var cuotas = parseInt(this.props.form.getFieldValue('nroCuotas'));
    var capitalInicial = this.props.form.getFieldValue('sumaTotal');

    if (isNaN(cuotas) || intereses == 1) {
      this.props.form.setFieldsValue({
        sumaInteres: 0,
      });
      return 0;
    }

    var capitalFinal = 0;

    var capitalF5 = intereses;
    var capitalC7 = cuotas;
    var total = Math.pow(capitalF5, capitalC7);

    var capital1 = total * capitalInicial;
    var capitalFinal = (capital1 / cuotas);


    this.props.form.setFieldsValue({
      sumaInteres: capitalFinal * cuotas,
    });

    return capitalFinal;
  };

  handleGenerarCuotas = (form) => {
    this.props.onGenerarCuotas(form);
    this.fetchTasa();

  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleValidateStock = (products, stockProducts) => {

    var elements = [];
    const productGroup = global.groupBy(products, (item) => [
      item.idProducto,
      item.numeroLote,
    ]);

    productGroup.forEach((item) => {
      /**** BUSCAR STOCK POR PRODUCTO Y LOTE ***/
      var stock = stockProducts.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      )[0].stock;

      /**** FILTRAR PRODUCTOS POR ID Y LOTE ***/
      var filteredProducts = products.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      );

      /**** SUMAR CANTIDAD DE PRODUCTOS POR ID Y LOTE ***/
      var total = filteredProducts.reduce(
        (a, b) => a + (b["cantidad"] || 0),
        0
      );

      /**** OBTENER NOMBRE DE PRODUCTOS AFECTADOS POR STOCK ***/
      var productNames = Array.from(
        new Set(filteredProducts.map((m) => m.nombre))
      );

      if (total > stock) {
        elements.push(
          <li>
            Stock no disponible para los productos:{" "}
            <b>{productNames.join(", ")}</b>
          </li>
        );
      }
    });

    return elements;
  };

  handleValidatDetalleAfecto = (products) => {
    var elements1 = [];
    var elements2 = [];
    products.forEach((item) => {
      if (item.flagAfecto) {
        elements1.push(item);
      } else {
        if (item.flagGratuito || item.flagISC) {
          elements1.push(item);
        } else {
          elements2.push(item);
        }
      }
    });

    if (
      elements1.length === products.length ||
      elements2.length === products.length
    )
      return true;
    else return false;
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (!err) {

        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante,
          idCliente: values.idCliente === undefined ? 0 : values.idCliente.key,
          idEstablecimientoCliente:
            values.idEstablecimientoCliente === undefined
              ? 0
              : values.idEstablecimientoCliente.key,
          idVendedor:
            values.idVendedor === undefined ? 0 : values.idVendedor.key,
          idAlmacen: values.idAlmacen.key,
          idMoneda: values.idMoneda.key,
          idListaPrecio: values.idListaPrecio.key,
          idEstablecimiento: values.idEstablecimiento.key,
          idCreditoEstado: 1,
          idProyecto: values.idProyecto.key == null ? 0 : values.idProyecto.key,
          idUsuarioRegistro: values.idUsuarioRegistro,
          serie: values.serie.toUpperCase(),
          documento: "", //values.documento,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaInicioStr: values.fechaInicioStr.format("DD/MM/YYYY"),
          fechaVencimientoStr: values.fechaVencimientoStr.format("DD/MM/YYYY"),
          diasVencimiento: parseInt(values.diasVencimiento),
          nroDias: parseInt(values.nroDias),
          nroCuotas: parseInt(values.nroCuotas),
          tipoCambio: parseFloat(values.tipoCambio),
          observacion: values.observacion,
          nroContrato: values.nroContrato,
          porcentajeIGV: 0,
          porcentajeDescuento: 0,
          totalDetalleAfecto: 0,
          totalDetalleInafecto: 0,
          totalDetalleGratuito: 0,
          totalDetalle: 0,
          importeDescuento: 0,
          subTotal: values.sumaSubTotal,
          iGV: values.sumaIgv,
          total: values.sumaTotal,
          totalInteres: values.sumaInteres,
          isc: 0,
          placa: values === undefined ? null : values.placa,
          nroSerie: values === undefined ? null : values.nroSerie,

          idTipoDocumento: values.idTipoDocumento.key == null ? 0 : values.idTipoDocumento.key,
          idFenologica: values.idFenologica.key == null ? 0 : values.idFenologica.key,
          idTasaInteres: values.idTasaInteres.key == null ? 0 : values.idTasaInteres.key,
          idPrestamo: values.idPrestamo.key == null ? 0 : values.idPrestamo.key,

          flag: true,
          flagCuota: values.flagCuota,
          idTipoProducto: values.idTipoProducto === undefined ? 0 : values.idTipoProducto.key,
          idFrecuencia: values.idFrecuencia === undefined ? 0 : values.idFrecuencia.key,
          listaCreditoDetalle: values.detalleProductos,
          listaCreditoReferencia: this.fetchReferencias(values),
          listaCreditoGarante: this.fetchGarantes(values),
          listaCreditoCuota: this.fetchCuotas(values),

        };

        if (!this.handleValidatDetalleAfecto(values.detalleProductos)) {
          dialog.warning("El detalle de productos no puedo contener afectos e inafectos.");
          return;
        }

        if (data.listaCreditoDetalle.length === 0) {
          dialog.warning("Por favor agregue por lo menos 1 producto.");
          return;
        }
        if (data.listaCreditoCuota.length == 0) {
          dialog.warning("Por favor agregue por lo menos 1 cuota.");
          return;
        }

        if (data.listaCreditoCuota.length != data.nroCuotas) {
          dialog.warning("El Nº de cuotas debe ser igual al detalle de cuotas");
          return;
        }


        if (!this.validate_fechaMayorQue(data.fechaStr, data.fechaVencimientoStr)) {
          dialog.warning("La fecha de vencimiento debe ser mayor que la fecha de emision");
          return false;
        }

        var latest = data.listaCreditoCuota[data.listaCreditoCuota.length - 1].fechaVencimientoStr;
        if (data.fechaVencimientoStr != latest) {
          dialog.warning("La ultima cuota debe tener la fecha igual que la fecha de vencimiento del documento");
          return false;
        }


        var _cliente = values.clientes.filter(e => e.id == data.idCliente);
        if (data.idVendedor != _cliente[0].idVendedor) {
          dialog.warning("El cliente seleccionado no esta asociado al vendedor");
          return;
        }

        var montoSoles = data.listaCreditoCuota.reduce((a, b) => a + (b["montoCuota"] || 0), 0);

        if (parseFloat(montoSoles).toFixed(2) != data.total) {
          dialog.warning("El monto total de cuotas, debe ser igual al monto del documento.");
          return;
        }
        const duplicateElements = this.toFindDuplicates(data.listaCreditoGarante);
        console.log(duplicateElements);

        this.props.onSave(data, this.props.form);
      }
    });
  };

  toFindDuplicates(values) {
    var hasDuplicate = false;
    values.map(v => v.idGarante).sort().sort((a, b) => {
      if (a === b) hasDuplicate = true
    })
    return hasDuplicate;
  }


  //#region  [MEDIO DE PAGO]

  fetchCuotas = (values) => {
    debugger
    var result = [];
    var keys = [];
    var obj = Object.assign({}, values.arrFechaVencimiento);
    var totalInteres = parseFloat(values.sumaInteres).toFixed(2);
    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        fechaVencimientoStr: values.arrFechaVencimiento[key].format("DD/MM/YYYY"),
        correlativo: parseFloat(values.arrCorrelativo[key]),
        montoCuota: parseFloat(values.arrMontoCuota[key]),
        montoInteres: parseFloat(totalInteres) > 0 ? (parseFloat(totalInteres) / parseInt(values.nroCuotas)) : 0,

      });
    });


    return result;
  };

  //#endregion  [END MEDIO DE PAGO]

  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart >= dateEnd) {
      return 0;
    }
    return 1;
  }

  fetchParameters = () => {
    var parameters = {};
    this.props.formValue.parameters.forEach((item) => {
      parameters[item.key] = item.value;
    });
    return parameters;
  };


  render() {
    const { getFieldDecorator, setFieldsValue, getFieldValue } =
      this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("clientes", {
      initialValue: this.props.formValues.clientes
    });
    getFieldDecorator("idTipoComprobante", {
      initialValue: this.props.formValues.idTipoComprobante,
    });
    getFieldDecorator("idUsuarioRegistro", {
      initialValue: this.props.formValues.idUsuarioRegistro,
    });
    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("sumaImporteDescuento", {
      initialValue: this.props.formValues.sumaImporteDescuento,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaIsc", {
      initialValue: this.props.formValues.sumaIsc,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("sumaInteres", {
      initialValue: this.props.formValues.sumaInteres,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.detalleProductos,
    });
    getFieldDecorator("detalleCuotas", {
      initialValue: this.props.formValues.listaComprobanteCuota,
    });
    getFieldDecorator("porcentajeDetraccion", {
      initialValue: this.props.formValues.porcentajeDetraccion,
    });
    getFieldDecorator("importeDetraccion", {
      initialValue: this.props.formValues.importeDetraccion,
    });
    getFieldDecorator("totalDetraccion", {
      initialValue: this.props.formValues.totalDetraccion,
    });
    getFieldDecorator("porcentajePercepcion", {
      initialValue: this.props.formValues.porcentajePercepcion,
    });
    getFieldDecorator("importePercepcion", {
      initialValue: this.props.formValues.importePercepcion,
    });
    getFieldDecorator("totalPercepcion", {
      initialValue: this.props.formValues.totalPercepcion,
    });
    getFieldDecorator("idTipoComprobanteImportado", {
      initialValue: this.props.formValues.idTipoComprobanteImportado,
    });
    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });

    getFieldDecorator("tasa", {
      initialValue: this.props.formValues.tasa,
    });

    getFieldDecorator("idTipoPrecio", {
      initialValue: this.props.formValues.idTipoPrecio,
    });

    var title = "Crédito";

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? `Registrar ${title}`
            : `Modificar ${title}`
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="1100px"
      >
        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                        onBlur={(e) =>
                          this.handleCompleteDecimals(
                            "tipoCambio",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        maxLength={8}
                        disabled
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("diasVencimiento", {
                      initialValue: this.props.formValues.diasVencimiento,
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_NUMBER),
                          message: "Formato incorrecto",
                        },
                      ],
                    })(
                      <Input
                        style={{ textAlign: "right" }}
                        placeholder="Ingresar días de vencimiento"
                        autoComplete="off"
                        className="first-input"
                        onBlur={(e) =>
                          this.findDaysAndDates(
                            "diasVencimiento",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaVencimientoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaVencimientoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        className="second-input"
                        onChange={(moment, value) =>
                          this.findDaysAndDates("fechaVencimientoStr", value)
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: this.props.formValues.idMoneda
                    ? { key: this.props.formValues.idMoneda }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue(
                        {
                          idListaPrecio: undefined,
                        },
                        () => {
                          this.props.onChange("idMoneda", option.key);
                        }
                      );
                    }}
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idEstablecimiento",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Almacén">
                {getFieldDecorator("idAlmacen", {
                  initialValue: this.props.formValues.idAlmacen
                    ? { key: this.props.formValues.idAlmacen }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Almacén"}
                    optionFilterProp="children"
                    loading={this.props.formValues.almacenLoading}
                    onChange={(option) =>
                      this.props.onChange(
                        "idAlmacen",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.almacenes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Lista de Precio">
                {getFieldDecorator("idListaPrecio", {
                  initialValue: this.props.formValues.idListaPrecio
                    ? { key: this.props.formValues.idListaPrecio }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Lista de Precio"}
                    optionFilterProp="children"
                    onChange={(option) =>
                      this.props.onChange(
                        "idListaPrecio",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.listasPrecio.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Vendedor">
                {getFieldDecorator("idVendedor", {
                  initialValue: this.props.formValues.idVendedor
                    ? { key: this.props.formValues.idVendedor }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Vendedor"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idVendedor", option.key, this.props.form)}

                  >
                    {/*                 <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option> */}
                    {this.props.formValues.vendedores.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.razonSocialEntidad}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Nro Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("documentoCliente", {
                      initialValue: this.props.formValues.documentoCliente,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ]
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        disabled
                        loading={this.props.formValues.clienteLoading}
                        onSearch={(value) =>
                          this.props.onBuscarCliente(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-9 form-group">
              <Form.Item label="Cliente">
                <InputGroup compact>

                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idCliente", {
                        initialValue: this.props.formValues.idCliente
                          ? { key: this.props.formValues.idCliente }
                          : undefined,
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width: `calc(100% - 40px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Cliente"}
                          optionFilterProp="children"
                          showArrow={false}
                          onSearch={this.handleSearchAutocompleteCliente}
                          onChange={this.handleChangeAutocompleteCliente}
                          disabled={this.props.formValues.id > 0 ? true : false}

                        >
                          {getFieldValue("clientes").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.numeroDocumento} - ${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idCliente")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idCliente: undefined,
                              documentoCliente: "",
                              idEstablecimientoCliente: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear");
                            }
                          );
                        }}
                        disabled={this.props.formValues.id > 0 ? true : false}

                      />
                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-2 form-group" hidden >
              <Form.Item label="IGV">
                {getFieldDecorator("idImpuesto", {
                  initialValue: this.props.formValues.idImpuesto
                    ? { key: this.props.formValues.idImpuesto }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"IGV"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idImpuesto", option.key, this.props.form)}
                  >
                    {this.props.formValues.tipoimpuesto.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>



            <div className="col-md-9 form-group">
              <Form.Item label="Dirección">
                {getFieldDecorator("idEstablecimientoCliente", {
                  initialValue: this.props.formValues.idEstablecimientoCliente
                    ? { key: this.props.formValues.idEstablecimientoCliente }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Direccion"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.direcciones.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre + " - " + item.direccion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator("idProyecto", {
                  initialValue: this.props.formValues.idProyecto
                    ? { key: this.props.formValues.idProyecto }
                    : 0,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    disabled={this.props.formValues.isReadOnly}
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

          </div>
          <div className="row">
            <div className={"col-md-6 form-group"} >
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group"  >
              <Form.Item label="Tipo Prestamo">
                {getFieldDecorator("idPrestamo", {
                  initialValue: this.props.formValues.idPrestamo
                    ? { key: this.props.formValues.idPrestamo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Tipo Prestamo"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idPrestamo", option.key, this.props.form)}
                  >
                    {this.props.formValues.tipoPrestamos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="N° Contrato">
                {getFieldDecorator("nroContrato", {
                  initialValue: this.props.formValues.nroContrato,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input
                    placeholder="Ingresar N° Contrato"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>
          </div>


          <div className="row">
            <div className="col-md-3 form-group"  >
              <Form.Item label="Facturación">
                {getFieldDecorator("idTipoDocumento", {
                  initialValue: this.props.formValues.idTipoDocumento
                    ? { key: this.props.formValues.idTipoDocumento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Tipo Documento"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idTipoProducto", option.key, this.props.form)}
                  >
                    {this.props.formValues.tiposComprobante.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group"
              hidden={this.props.formValues.idPrestamo == 2 ? false : true}
            >
              <Form.Item label="Placa">
                {getFieldDecorator("placa", {
                  initialValue: this.props.formValues.placa,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input placeholder="Ingresar Placa" autoComplete="off" />
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group"
              hidden={this.props.formValues.idPrestamo == 2 ? false : true}
            >
              <Form.Item label="N° Serie">
                {getFieldDecorator("nroSerie", {
                  initialValue: this.props.formValues.nroSerie,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input placeholder="Ingresar N° Serie" autoComplete="off" />
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group"
              hidden={this.props.formValues.idPrestamo == 1 ? false : true}
            >
              <Form.Item label="Cultivo">
                {getFieldDecorator('idCultivo', {
                  initialValue: this.props.formValues.idCultivo
                    ? { key: this.props.formValues.idCultivo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Cultivo"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idCultivo",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.cultivos.map(item => (
                      <Option key={item.id} value={item.id}>{item.nombre}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group"
              hidden={this.props.formValues.idPrestamo == 1 ? false : true}
            >
              <Form.Item label="Etapa Fenologica">
                {getFieldDecorator('idFenologica', {
                  initialValue: this.props.formValues.idFenologica
                    ? { key: this.props.formValues.idFenologica }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Fenologica"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.fenologicas.map(item => (
                      <Option key={item.id} value={item.id}>{item.nombre}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group"  >
              <Form.Item label="Tipo Servicio">
                {getFieldDecorator("idTipoProducto", {
                  initialValue: this.props.formValues.idTipoProducto
                    ? { key: this.props.formValues.idTipoProducto }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Tipo Servicio"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idTipoProducto", option.key, this.props.form)}
                  >
                    {this.props.formValues.tipoServicios.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


          </div>

          <div className="row">
            <div className="col-md-3 form-group"  >
              <Form.Item label="Tipo Crédito">
                {getFieldDecorator("idCredito", {
                  initialValue: this.props.formValues.idCredito
                    ? { key: this.props.formValues.idCredito }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Tipo Crédito"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idCredito",
                        option.key,
                        this.props.form
                      );
                    }}>
                    <Option value="0" key="0">Sin Credito</Option>
                    {this.props.formValues.tipoCreditos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group"  >
              <Form.Item label="Tasa de Interes">
                {getFieldDecorator("idTasaInteres", {
                  initialValue: this.props.formValues.idTasaInteres
                    ? { key: this.props.formValues.idTasaInteres }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Tasa"}
                    optionFilterProp="children"
                    onChange={(value, option) => {
                      this.props.form.setFieldsValue({ tasa: option.props.data });
                      this.props.form.setFieldsValue({ idTasaInteres: value.key });
                      //this.props.onChange("idFrecuencia", option.key, this.props.form)
                    }}
                  >
                    {this.props.formValues.tasaIntereses.map((item) => (
                      <Option key={item.id} value={item.id} data={item.tasa}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Frecuencia de Cuotas">
                {getFieldDecorator("idFrecuencia", {
                  initialValue: this.props.formValues.idFrecuencia
                    ? { key: this.props.formValues.idFrecuencia }
                    : 0,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Frecuencia"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      if (option.key == 1) {
                        this.props.form.setFieldsValue({ nroDias: 0 });
                      }
                      this.props.form.setFieldsValue({ flagCuota: false });

                      this.props.onChange("idFrecuencia", option.key, this.props.form)
                    }}
                  >
                    {this.props.formValues.frecuencias.map(item => (
                      <Option key={item.id} value={item.id}>{item.nombre}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Aplica Cuota Fija">
                {getFieldDecorator("flagCuota", {
                  initialValue: this.props.formValues.flagCuota,
                  valuePropName: "checked",
                })(
                  <Checkbox
                    onChange={(e) =>
                      this.props.onChange(
                        "flagCuota",
                        e.target.checked,
                        this.props.form
                      )
                    }
                    disabled={[1, 4].includes(this.props.form.getFieldValue('idFrecuencia').key)}

                  ></Checkbox>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="N° Cuotas">
                {getFieldDecorator("nroCuotas", {
                  initialValue: this.props.formValues.nroCuotas,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input
                    placeholder="Ingresar N° Cuotas"
                    autoComplete="off"
                    onKeyPress={global.onKeyPressNumber}

                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label={this.props.form.getFieldValue('flagCuota') ? "Fecha de Desembolso" : "Fecha Inicio Cuotas"}>
                <Form.Item>
                  {getFieldDecorator("fechaInicioStr", {
                    initialValue: moment(
                      this.props.formValues.fechaInicioStr,
                      "DD/MM/YYYY"
                    ),
                    rules: [
                      {
                        type: "object",
                        required: true,
                        message: "Requerido",
                      },
                    ],
                  })(
                    <DatePicker
                      className="first-input"
                      placeholder="Seleccione fecha"
                      prefix={
                        <Icon
                          type="filter"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      format="DD/MM/YYYY"
                      onChange={(moment, value) =>
                        this.props.onChange(
                          "fechaInicioStr",
                          value,
                          this.props.form
                        )
                      }
                    />
                  )}
                </Form.Item>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label={this.props.form.getFieldValue('flagCuota') ? "N° Dias despues de Desembolso" : "N° Dias"}>
                {getFieldDecorator("nroDias", {
                  initialValue: this.props.formValues.nroDias,
                })(
                  <Input
                    placeholder="Ingresar N° Dia"
                    autoComplete="off"
                    disabled={this.props.form.getFieldValue('idFrecuencia').key == 1}
                    onKeyPress={global.onKeyPressDecimals}
                  />
                )}
              </Form.Item>
            </div>


            <div className="col-md-2 form-group">
              <Form.Item label=".">
                <Button
                  icon="plus-circle"
                  type="danger"
                  onClick={() => this.handleGenerarCuotas(this.props.form)}
                >
                  Generar Cuotas
                </Button>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() =>
                        this.props.onAgregarDetalle(this.props.form.setFieldsValue, this.props.form.getFieldValue)
                      }
                    >
                      Agregar
                    </Button>

                    {auth.user().planCode == "PLA001" ? (
                      <Button
                        icon="plus"
                        type="primary"
                        onClick={() => this.props.OnItemLibre(this.props.form.setFieldsValue, this.props.form)}
                      >
                        Agregar item libre
                      </Button>
                    ) : null}
                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Productos y Servicios
                    </span>
                  }
                  key="1"
                >
                  <Productos
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    precioUnitarioDisabled={
                      this.props.formValues.precioUnitarioDetailDisabled
                    }
                    totalDisabled={this.props.formValues.totalDetailDisabled}
                    onRemove={this.handleRemoverProducto}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Referencias
                    </span>
                  }
                  key="2"
                >
                  <Referencias
                    dataSource={this.props.formValues.listaComprobanteReferencia}
                    tiposComprobante={this.props.formValues.tiposComprobante}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>

                <TabPane
                  visible={false}
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Cuotas
                    </span>
                  }
                  key="3"
                >
                  <Cuotas
                    dataSource={this.props.formValues.listaComprobanteCuota}
                    onRemove={this.props.onRemoverCuota}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <Icon type="user" /> Garante
                    </span>
                  }
                  key="4"
                >
                  <Garante
                    dataSource={this.props.formValues.listaComprobanteGarante}
                    garantes={this.props.formValues.garantes}
                    onRemove={this.props.onRemoverGarante}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onChangeTotals={this.handleChangeTotals}
            onGetFieldDecorator={getFieldDecorator}
            onGetFieldValue={getFieldValue}
          />
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
